export default __webpack_public_path__ + "static/media/4_breath_work.1e0f47f9.png";